module.exports = __webpack_public_path__ + "img/img_carousel.0f44a1c0.webp";